import { useMemo } from 'react'
import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import { isComponentOn } from '@aytm/app/stats/page/question-views/components/lib/utils'
import { isNoneChartMode } from '@aytm/app/stats/page/question-views/components/lib/chart-modes'
import { calcTableProps } from '@aytm/app/stats/page/question-views/info-view/lib/table-utils'

import { getModelValue } from '@aytm/app/stats/lib/stat-page'

import Table from '@aytm/app/stats/components/data-views/table/components/Table'
import ChartPlaceholder from '@aytm/app/stats/page/question-views/components/charts/placeholders/Chart'
import Chart from '@aytm/app/stats/page/question-views/info-view/components/charts/bars/Chart'
import BlockWrapper from '@aytm/app/stats/page/question-views/components/BlockWrapper'

// Info-view bars block: the bars/stacked-bars chart plus its single-category items-list table.
// Replaces info_view/charts/bars.coffee (BarsChartView + BarsView + the generic ItemsListView).
// The table uses the lightweight calcTableProps port; the coffee ItemsListView extras (sort
// persistence, comments, skips-to, trait sub-tables, rType) are intentionally not reproduced.
// Chart is placeholder-free (bars/exportable.ts mounts it headlessly) so the placeholder lives here.
const Block = ({ format, components, categories, block, isAnimated, answer, footer, ...chart }) => {
  // a none the question declares or the report sets hides the chart; the table stays
  const showChart = !isNoneChartMode(chart.questionChartMode, chart.globalChartMode)

  // Same gate as the legacy BarsView: table on unless components.table is off, single category only.
  const showTable = isComponentOn(components, 'table') && 1 === categories?.length

  // resolved outside the memo and named in its dependencies -- read inside, the first figure would
  // be the only one the table ever drew
  const percentDecimals = getModelValue('percentDecimals')

  const itemsListProps = useMemo(
    () => (showTable ? calcTableProps({ block, format, answer, percentDecimals }) : null),
    [showTable, block, format, answer, percentDecimals]
  )

  return (
    <BlockWrapper>
      {showChart ? (
        <ChartPlaceholder required isLoading={answer === 'loading'} isAnimated={isAnimated}>
          <Chart {...chart} answer={answer} format={format?.chart || {}} />
        </ChartPlaceholder>
      ) : null}
      {itemsListProps ? <Table {...itemsListProps} /> : null}
    </BlockWrapper>
  )
}

Block.displayName = 'Block'

Block.propTypes = {
  footer: PropTypes.any,
  format: PropTypes.object,
  components: PropTypes.object,
  categories: PropTypes.array,
  block: PropTypes.object,
  isAnimated: PropTypes.bool,
  answer: answerPropType
}

export default Block
